// src/shared/components/ActiveDoctorsSelector/ActiveDoctorsSelector.js
import React, { useState } from "react";
import { useActiveDoctors } from "../../../context/active-doctors-context";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import Checkbox from "@mui/material/Checkbox";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import "./ActiveDoctorsSelector.scss";

function ActiveDoctorsSelector() {
  const { availableDoctors, activeDoctorIds, toggleDoctor } =
    useActiveDoctors();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToggle = (doctorId) => {
    toggleDoctor(doctorId);
  };

  // If there are no available doctors or only one doctor, don't show the selector
  if (!availableDoctors || availableDoctors.length <= 1) {
    return null;
  }

  const activeCount = activeDoctorIds.length;
  const totalCount = availableDoctors.length;

  return (
    <div className="activeDoctorsSelector">
      <Tooltip
        title={`Médicos ativos: ${activeCount}/${totalCount}`}
        placement="bottom"
      >
        <IconButton
          onClick={handleClick}
          color="primary"
          aria-label="selecionar médicos ativos"
          className="activeDoctorsSelector__button"
        >
          <div className="activeDoctorsSelector__indicator">
            <MedicalServicesIcon />
            <span className="activeDoctorsSelector__count">{activeCount}</span>
          </div>
        </IconButton>
      </Tooltip>

      <Menu
        id="active-doctors-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "active-doctors-button",
        }}
      >
        <div className="activeDoctorsSelector__menu-header">
          <span>Médicos Ativos</span>
          <span className="activeDoctorsSelector__menu-subheader">
            Selecione os médicos para receber notificações
          </span>
        </div>

        {availableDoctors.map((doctor) => (
          <MenuItem
            key={doctor.id}
            onClick={() => handleToggle(doctor.id)}
            className="activeDoctorsSelector__menuItem"
          >
            <Checkbox
              checked={activeDoctorIds.includes(doctor.id)}
              color="primary"
              className="activeDoctorsSelector__checkbox"
            />
            <div
              className="activeDoctorsSelector__color-indicator"
              style={{ backgroundColor: doctor.cor }}
            />
            <span className="activeDoctorsSelector__doctor-name">
              {doctor.nome}
            </span>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

export default ActiveDoctorsSelector;
